import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { ICashRegisterEntriesQueryParams, ICashRegisterEntry, IQueryResult } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<ICashRegisterEntry>, ICashRegisterEntriesQueryParams>>(undefined as any);
